import { createTheme } from '@mui/material';
import { defaultTheme } from './default-theme';
var lightTheme = createTheme(defaultTheme);
export { lightTheme };